Prism.languages.gettext = {
  comment: [{
    pattern: /# .*/,
    greedy: !0,
    alias: "translator-comment"
  }, {
    pattern: /#\..*/,
    greedy: !0,
    alias: "extracted-comment"
  }, {
    pattern: /#:.*/,
    greedy: !0,
    alias: "reference-comment"
  }, {
    pattern: /#,.*/,
    greedy: !0,
    alias: "flag-comment"
  }, {
    pattern: /#\|.*/,
    greedy: !0,
    alias: "previously-untranslated-comment"
  }, {
    pattern: /#.*/,
    greedy: !0
  }],
  string: {
    pattern: /(^|[^\\])"(?:[^"\\]|\\.)*"/,
    lookbehind: !0,
    greedy: !0
  },
  keyword: /^msg(?:ctxt|id|id_plural|str)\b/m,
  number: /\b\d+\b/,
  punctuation: /[\[\]]/
}, Prism.languages.po = Prism.languages.gettext;